import { Button } from '@affine/component/ui/button';
import { useI18n } from '@affine/i18n';
import { useTheme } from 'next-themes';
import { type ReactNode } from 'react';

import {
  FYDEOS_NOTES_LOGO,
  getCurrentFydeOSBrandLinks,
} from '../product-brand';
import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
import { DesktopNavbar } from './desktop-navbar';
import * as styles from './index.css';
import { MobileNavbar } from './mobile-navbar';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const t = useI18n();
  const { resolvedTheme } = useTheme();
  const brandLinks = getCurrentFydeOSBrandLinks();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav}>
          <a
            href={brandLinks.notesHome}
            rel="noreferrer"
            className={styles.affineLogo}
          >
            <img
              className={styles.fydeosLogo}
              src={
                resolvedTheme === 'dark'
                  ? FYDEOS_NOTES_LOGO.dark
                  : FYDEOS_NOTES_LOGO.light
              }
              alt="FydeOS Notes"
            />
          </a>

          <DesktopNavbar />
          <Button
            onClick={() =>
              open(brandLinks.help, '_blank', 'noopener,noreferrer')
            }
            className={styles.hideInSmallScreen}
          >
            {t['com.affine.other-page.nav.contact-us']()}
          </Button>
          <MobileNavbar />
        </div>
      )}

      {children}
    </div>
  );
};
